import { HeartHandshake, DoorOpen, Flame } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const TAGLINE = "Compassion. Opportunity. Motivation.";

const pillars = [
  {
    letter: "C",
    word: "Compassion",
    icon: HeartHandshake,
    text: "Every resident is met the way Jaliyah met people — with warmth, patience, and zero judgment. Dignity is the first thing we offer.",
  },
  {
    letter: "O",
    word: "Opportunity",
    icon: DoorOpen,
    text: "A safe home, a structured day, and a real plan. We open doors to treatment, work, education, and a life worth staying for.",
  },
  {
    letter: "M",
    word: "Motivation",
    icon: Flame,
    text: "Recovery is a daily choice. Our staff and peer community keep the fire lit on the hard days — and celebrate every win.",
  },
];

export function Pillars({ dark = false }) {
  return (
    <section
      data-testid="com-pillars-section"
      className={`py-20 lg:py-28 relative overflow-hidden ${dark ? "bg-[#2E1065] grain" : "bg-[#FAF8F5]"}`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className={`text-xs uppercase tracking-[0.25em] font-bold mb-3 ${dark ? "text-amber-400" : "text-[#B45309]"}`}>
            What C.O.M. Means To Us
          </p>
          <h2
            className={`font-display font-black text-3xl sm:text-4xl lg:text-5xl leading-tight ${dark ? "text-[#FAF8F5]" : "text-[#1E1B4B]"}`}
            data-testid="com-pillars-heading"
          >
            {TAGLINE}
          </h2>
          <p className={`mt-4 text-base leading-relaxed ${dark ? "text-purple-200" : "text-slate-600"}`}>
            Three words guide every home under the Jaliyah's House of Hope umbrella. They are how we hire, how we
            care, and how we measure a good day.
          </p>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {pillars.map((p, i) => (
            <Reveal key={p.letter} delay={i * 0.12}>
              <div
                data-testid={`com-pillar-${p.letter.toLowerCase()}`}
                className={`group relative h-full rounded-[2rem] p-8 border transition-all duration-500 hover:-translate-y-1.5 ${
                  dark
                    ? "bg-white/5 border-amber-400/30 hover:bg-white/10"
                    : "bg-white border-purple-100 shadow-sm hover:shadow-2xl"
                }`}
              >
                <span
                  className={`absolute top-4 right-6 font-display font-black text-[7rem] leading-none select-none pointer-events-none transition-colors duration-500 ${
                    dark ? "text-amber-400/10 group-hover:text-amber-400/20" : "text-[#F3E8FF] group-hover:text-[#FEF3C7]"
                  }`}
                  aria-hidden="true"
                >
                  {p.letter}
                </span>
                <div className={`relative w-14 h-14 rounded-2xl flex items-center justify-center mb-6 ${dark ? "bg-amber-400 text-[#2E1065]" : "bg-[#5B21B6] text-white"}`}>
                  <p.icon size={26} />
                </div>
                <h3 className={`relative font-display font-bold text-2xl ${dark ? "text-[#FAF8F5]" : "text-[#2E1065]"}`}>
                  <span className={dark ? "text-amber-400" : "text-[#F59E0B]"}>{p.letter}</span>
                  {p.word.slice(1)}
                </h3>
                <p className={`relative mt-3 text-sm leading-relaxed ${dark ? "text-purple-200" : "text-slate-600"}`}>{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
